import { createAsyncThunk } from "@reduxjs/toolkit";
import { TentorServices } from "Services/axios/Tentor.Service";
import { toast } from "react-toastify";
import { handleApiError } from 'Features/Common/ErrorHandler';

export const fetchTentors = createAsyncThunk(
	"Tentors/fetchTentors",
	async (filters) => {
		try {
			const response = await TentorServices.getAll(filters);
			return response.data;
		} catch (error) {
			handleApiError(error);
			throw error;
		}
	}
);

export const submitTentor = createAsyncThunk(
	"Tentors/submitTentor",
	async (data) => {
		try {
			const formData = new FormData();
			formData.append("name", data.name);
			formData.append('email', data.email);
			formData.append('status', data.status);
			formData.append("phone", data.phone);
			formData.append("mastered_fields", data.mastered_fields);
			if (Array.isArray(data.education)) {
				data.education.forEach((edu) => {
					formData.append("education[]", edu);
				});
			} else {
				formData.append("education[]", data.education);
			}
			if (Array.isArray(data.experience)) {
				data.experience.forEach((exp) => {
					formData.append("experience[]", exp);
				});
			} else {
				formData.append("experience[]", data.experience);
			}
			formData.append('password', data.password);
			data.photo && formData.append("photo", data.photo);
			let response;
			if (data.isUpdate) {
				response = await TentorServices.update(data.id, formData);
				toast.success("Tentor berhasil diperbarui", {
					position: toast.POSITION.TOP_RIGHT,
				});
			} else {
				response = await TentorServices.create(formData);
				toast.success("Tentor berhasil ditambahkan", {
					position: toast.POSITION.TOP_RIGHT,
				});
			}
			data.successCallback && data.successCallback();
			return response.data.data;
		} catch (error) {
			handleApiError(error);
			throw error;
		}
	}
);

export const deleteTentor = createAsyncThunk(
	"Tentors/deleteTentor",
	async (id) => {
		try {
			const response = await TentorServices.delete(id);
			return response.data.data;
		} catch (error) {
			handleApiError(error);
			throw error;
		}
	}
);
